module.exports = __webpack_public_path__ + "img/3.fa20d78a.jpeg";